<template>
  <div>
    <button class="ui pink button" @click="openModal">
      <span v-if="checkedCategory">
        {{ categoryName }}
      </span>
      <span v-else> Select Category </span>
    </button>
    <modal ref="modal">
      <div class="tree">
        <ul class="tree-list">
          <branch
            :branch="treeData"
            :handle-check="handleCheck"
            :checked-category="checkedCategory"
          ></branch>
        </ul>
      </div>
    </modal>
  </div>
</template>
<style>
.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>
<script>
export default {
  name: 'Tree',
  props: {
    tree: {
      type: Object,
      default: null
    },
    customerCheckedCategory: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    checkedCategory: null
  }),
  computed: {
    treeData() {
      return Object.values(this.tree)[0]
    },
    categoryName() {
      return this.checkedCategory.name
    }
  },
  mounted() {
    if (this.customerCheckedCategory) {
      this.checkedCategory = this.customerCheckedCategory
    }
  },
  methods: {
    openModal() {
      this.$refs.modal.open()
    },
    handleCheck(branch) {
      this.checkedCategory = branch
      this.$emit(
        'branch-checked',
        this.checkedCategory ? this.checkedCategory : null
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Tree.vue?2c0ba484